import styled from "styled-components";

const EmphasisedText = styled.p`
  font-size: 0.9em;
  font-weight: bold;
  margin: 0;
`;

export default EmphasisedText;
